import {useStyles} from "lincd/lib/utils/Hooks";
import "./Section.scss"
import * as style from "./Section.scss.json"

export const Section = (props) => {
    let styles = useStyles(props,style.Section);
    return <div {...styles}>
        {props.children}
    </div>
}